import { createContext, useEffect, useState } from "react";

export const MenuContext = createContext({});

export const MenuProvider = ({ children }) => {
  const [menuContext, setMenuContext] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [menuItems, setMenuItems] = useState({});
  const [menuChange, setMenuChange] = useState(false);
  const filterMenu = (menu, name) => {
    const tempSearch = searchTerm.toLowerCase();
    if (menu["metadata"] !== "item") {
      var tempObj = {};
      var isPresent = false;
      Object.keys(menu).map((index) => {
        if (index !== "metadata" && index !== "hotelID") {
          const tempObject = menu[index];
          if (tempObject["metadata"] === "category") {
            const temp = filterMenu(tempObject, index);
            if (temp) {
              tempObj = { ...tempObj, [index]: temp };
              isPresent = true;
            }
          } else if (tempObject["metadata"] === "item") {
            if (filterMenu(tempObject, index)) {
              isPresent = true;
              tempObj = { ...tempObj, [index]: tempObject };
            }
          }
        } else {
          tempObj = { ...tempObj, [index]: menu[index] };
        }
      });
      if (isPresent) {
        return tempObj;
      }
    } else {
      const lowName = name.toLowerCase();
      return lowName.includes(tempSearch);
    }
  };

  useEffect(() => {
    if (menuContext === menuItems) {
      setMenuChange(false);
    } else {
      setMenuChange(true);
    }
  }, [menuContext]);
  useEffect(() => {
    setMenuContext(menuItems);
  }, [menuItems]);
  useEffect(() => {
    const alteredMenu = filterMenu(menuItems);
    setMenuContext(alteredMenu);
    if (searchTerm === "") {
      setMenuContext(menuItems);
    }
  }, [setSearchTerm, searchTerm]);
  const getMenu = async () => {
    const hotelIDvalue = localStorage.getItem("hotelID");
    const requestObject = {
      hotelID: hotelIDvalue,
    };
    var userToken;
    if (localStorage.getItem("user")) {
      userToken = localStorage.getItem("user");
    } else if (localStorage.getItem("affiliate")) {
      userToken = localStorage.getItem("affiliate");
    }
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/menu/getmenu",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    var tempObject = {};
    Object.keys(result).map((index) => {
      if (index !== "_id") {
        tempObject = { ...tempObject, [index]: result[index] };
      }
    });
    return tempObject;
  };
  const updateMenu = async () => {
    console.log(JSON.stringify(menuContext));

    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/menu/addmenu",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": localStorage.getItem("user"),
        },
        body: JSON.stringify(menuContext),
      }
    );
    const result = await response.text();
    window.location.reload();
  };
  useEffect(() => {
    const loadMenu = async () => {
      const menu = await getMenu();
      setMenuItems(menu);
    };
    loadMenu();
  }, []);

  const value = {
    menuContext,
    setMenuContext,
    searchTerm,
    setSearchTerm,
    menuChange,
    updateMenu,
  };
  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
